import { TinyColor, isReadable } from '@ctrl/tinycolor';

export function capitalize(s: string) {
  if (s) {
    return s[0].toUpperCase() + s.slice(1);
  }
  return s;
}

export function toTitleCase(s: string) {
  if (!s) {
    return '';
  }
  return s
    .replace(/^custom_/, '')
    .toLowerCase()
    .replace(/[_-]/g, ' ')
    .split(' ')
    .map(capitalize)
    .join(' ');
}

export const transparentize = (color: string, opacity: number) =>
  new TinyColor(color).setAlpha(opacity).toRgbString();

export const lighten = (color: string, amount: number) =>
  new TinyColor(color).lighten(amount).toRgbString();

export const darken = (color: string, amount: number) =>
  new TinyColor(color).darken(amount).toRgbString();

export function computeForegroundColor(backgroundColor: string) {
  if (isReadable('#fff', backgroundColor, { level: 'AA', size: 'large' })) {
    return '#fff';
  }
  return '#000';
}
